export default "__VITE_ASSET__CQh5wcWc__"